import { FabricObject } from 'fabric';

/**
 * Selection Styles Configuration — the single source of truth for how selected
 * canvas objects look, so every consumer gets a unified selection appearance.
 */

/** Selection style for a single selected object: solid black border. */
export const SELECTION_STYLES = {
    borderColor: 'black',
    cornerColor: 'black',
    cornerSize: 12,
    transparentCorners: false,
} as const;

/** Selection style for a multi-selection (ActiveSelection): dashed black border. */
export const MULTI_SELECTION_STYLES = {
    borderColor: 'black',
    cornerColor: 'black',
    cornerSize: 12,
    transparentCorners: false,
    borderDashArray: [5, 5],
} as const;

/**
 * Apply single-selection styles to an existing object (e.g. objects restored from
 * Yjs, paths produced by PencilBrush).
 */
export function applySelectionStyles(obj: FabricObject): void {
    obj.set(SELECTION_STYLES);
}

/** Apply multi-selection styles to an ActiveSelection object. */
export function applyMultiSelectionStyles(obj: FabricObject): void {
    obj.set(MULTI_SELECTION_STYLES);
}

/**
 * Selection styles as a plain object, to spread into a new object's options.
 *
 * @example
 * const rect = new Rect({ left: 0, top: 0, ...getSelectionStylesForCreation() });
 */
export function getSelectionStylesForCreation(): typeof SELECTION_STYLES {
    return { ...SELECTION_STYLES };
}
